import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import cn from 'classnames';

import styles from './Modal.module.css';

function ModalComponent({ onClose, title, children, className, size }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(onClose());

  return (
    <>
      <Modal
        size={size}
        className={cn(`text-muted ${size}`, className)}
        show={true}
        onHide={handleClose}
        onClick={evt => evt.stopPropagation()}
      >
        <Modal.Header className={styles.Header} closeButton>
          <Modal.Title>
            <h5 className="text-reset text-center align-middle">{title}</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={`text-reset ${styles.Body}`}>{children}</Modal.Body>
      </Modal>
    </>
  );
}

export default ModalComponent;
